export default "__VITE_ASSET__BSLJ3_t9__"